export default{
        column: [
                {
                  type: 'select',
                  label: '项目名称',
                  dicData: [],
                  cascaderItem: [],
                  span: 8,
                  display: true,
                  props: {
                    label: 'name',
                    value: 'id'
                  },
                  formslot:true,
                  prop: 'projectId',
                  required: true,
                  rules: [
                    {
                      required: true,
                      message: '请选择下拉选择器'
                    }
                  ]
                },
                {
                  type: 'select',
                  label: '调入仓库',
                  dicData: [],
                  cascaderItem: [],
                  span: 8,
                  display: true,
                
                  props: {
                    label: 'name',
                    value: 'id'
                  },
                  formslot:true,
                  prop: 'destWarehouseId',
                  required: true,
                  rules: [
                    {
                      required: true,
                      message: '请选择仓库'
                    }
                  ]
                },
                {
                  type: 'select',
                  label: '调出仓库',
                  dicData: [],
                  cascaderItem: [],
                  span: 8,
                  display: true,
                
                  props: {
                    label: 'name',
                    value: 'id'
                  },
                  formslot:true,
                  prop: 'originWarehouseId',
                  required: true,
                  rules: [
                    {
                      required: true,
                      message: '请选择仓库'
                    }
                  ]
                },
                
                {
                  type: 'input',
                  label: '调拨单号',
                  disabled:true,
                  span:8,
                  prop: 'allotNo',
                  required: true,
                  rules: [
                    {
                      required: true,
                      message: '单号'
                    }
                  ]
                },

                {
                  type: 'textarea',
                  label: '调拨备注',
                  span: 24,
                  maxlength: 300,
                  showWordLimit: true,
                  display: true,
                  prop: 'description'
                },
                {
                  type: 'textarea',
                  label: '',
                  labelWidth:0,
                  span: 24,
                  formslot:true,
                  display: true,
                  prop: 'dataList'
                }
              ],
              labelPosition: 'right',
              labelSuffix: '：',
              labelWidth: 100,
              gutter: 0,
              // submitBtn: false,
              submitIcon:'none',
              // submitText: '保存',
              emptyBtn:false,
              menuBtn: false,
              menuPosition: 'center',
              disabled:false,
              
}
